var map = {
	"./code.svg": "d7a5",
	"./empty.svg": "c091",
	"./histogram.svg": "4c14",
	"./line chart.svg": "d82a",
	"./manageBoard.svg": "ac9c",
	"./pc.svg": "f545",
	"./wechat.svg": "80da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";